import { motion } from "framer-motion";

/**
 * KPI tile — used in Vendors, Appointments, Dashboard.
 * Props: label, value, delta (optional muted line), index (for stagger), testId
 */
export function NexaKPI({ label, value, delta, index = 0, testId }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 4 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, delay: 0.04 * index }}
      className="lux-card p-3"
      data-testid={testId}
    >
      <div className="text-[8px] tracking-[0.14em] uppercase text-nexa-mute font-semibold">{label}</div>
      <div className="mt-1 text-[15px] font-semibold text-nexa-ink tracking-[-0.01em]">{value}</div>
      {delta && <div className="mt-0.5 text-[9px] text-nexa-mute">{delta}</div>}
    </motion.div>
  );
}
